export const SET_USER = "SET_USER";

export const SET_LOADING_STATE = "SET_LOADING_STATE";

export const GET_ARTICLES = "GET_ARTICLES";
